import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";

const SessionTimerDisplay = () => {
    const token = useSelector((state) => state.auth.token);
    const [timeLeft, setTimeLeft] = useState(null);

    useEffect(() => {
        if (!token) return;

        const calculateTimeLeft = () => {
            try {
                const decoded = jwtDecode(token);
                const currentTime = Date.now();
                const expTime = decoded.exp * 1000;
                const remaining = Math.max(0, Math.ceil((expTime - currentTime) / 1000));
                setTimeLeft(remaining);
            } catch (error) {
                console.error("Error decoding token for timer:", error);
            }
        };

        calculateTimeLeft();
        const interval = setInterval(calculateTimeLeft, 1000);

        return () => clearInterval(interval);
    }, [token]);

    if (timeLeft === null) return null;

    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    const formattedTime = `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;

    return (
        <div style={{ color: '#4a5568', fontWeight: 600, marginTop: '5px' }}>
            <span>Session Expires in: </span>
            <span style={{ color: timeLeft < 120 ? 'red' : 'green' }}>{formattedTime}</span>
        </div>
    );
};

export default SessionTimerDisplay;
